<template>
    <section id="page-wrapper">
        <Navbar/>
         <Spinner v-if="isLoading" :color="'text-light'" />
        <div class="calltoaction px-2" >
            <section class="row" v-if="!isLoading">
                <div class="col-sm-9 text-center">
               <div class="col-xs-12 col-sm-12 py-3">
                    <div class="card">
                        <div class="card-header">
                            <h2>{{vision.heading}}</h2>
                        </div>
                        <div class="card-body">
                           <img v-if="author"  :src="author.image" class="img-fluid" alt="">
                          <p v-if="author" class="blog-post-meta pb-4 pt-3">{{author.date && author.date | moment}} by {{author.author}}</p>
                           <p v-if="!author" class="blog-post-meta pb-4">{{vision.created_at && vision.created_at | moment}} 
                                by {{vision.created_by && vision.created_by[0].first_name}} {{vision.created_by && vision.created_by[0].last_name}}</p>
                                 <!-- <img v-if="!author" class="img-thumbnail" :src="`${url()}/${vision.pic}`" alt=""> -->
                                <!-- <img v-if="vision.pic" class="img-thumbnail" :src="vision.pic" alt=""> -->
                            <p class="pt-4 text-justify">{{vision.summary}}</p>
                            <button v-if="vision.thinkers_critique.length == 0" style="float:left" @click="addCritique(vision.id)">
                                Add critique
                            </button>
                        </div>
                       
                    </div>
                </div>
                </div>
                <div class="col-sm-3">
                    <DebateSidebar/>
                </div>
            </section>
        </div>
        <FinalFooter />
    </section>
</template>

<script>
/* allow-no-unused-vars */
import FinalFooter from '../FinalFooter'
import Navbar from '../appBar'
import DebateSidebar from '../debateSidebar'
import authors from '../../helpers/debates'
import challengeAuthors from '../../helpers/challengeAuthors'
import Spinner from '@/components/Spinner'
import moment from 'moment'
import url from '../../helpers/url'
    export default {
        components:{
            Navbar,
            Spinner,
            DebateSidebar,
            FinalFooter
        },
        
          filters: {
        moment: function (date) {
            return moment(date).format('MMMM Do YYYY');
        }
        },
        data() {
            return {
                vision: {},
                author: {},
                isLoading:false,
            }
        },
         methods:{
             url() {
                 return url()
             },
             addCritique(challengeID) {
                    const user = this.$session.get('entity')
                    if(!user) {
                        window.location.replace(`/redirect?service=login`)
                    }
                    this.$router.replace(`/challenge/${challengeID}/add_critique`)
                },
            fetchLeadersVision(){
                this.isLoading = true
                this.$store.dispatch('fetchLeadersVision')
                .then(response =>{
                
                    const data = response.data.find(vision => vision.id == this.$route.params.challengeID)
                     if(!data) {
                        this.$router.push({name:'pageNotfound'})
                    }
                    this.vision = data
                    const author = challengeAuthors.find(author => author.id == data.id)
                    this.author = author
                    this.isLoading = false
                      
                       
                })
                .catch(err => {
                    //     if(err?.response?.data == undefined) {
                    //     this.toast({
                    //         message:'Network error. Check network connection and try again.',
                    //         type:'error'
                    //     })
                    // }
                    })
            }
        },
         created() {
          this.fetchLeadersVision()
    },
    }
</script>

<style >

.calltoaction{
    padding-top: 150px;
    padding-left: 10px;
    padding-right: 10px;
}
.card-user {
  position: absolute;
  right: 10px;
  top: 10px;
}
.card-category {
  position: absolute;
  top: 10px;
  left: 10px;
  font-size: 20px;
}
h2{
    text-transform: uppercase;
}
.blog-post-meta {
margin-bottom: 20px;
color: #999;
}
.image{
    width:100%;
    height: 500px;
}
#page-wrapper{
    background-color: #ba2428;
}
    button{
        background-color: #ba2428;
        color:#fff;
        border:1px solid #ba2428;
        padding:10px;
        transition: all 0.5s;
        outline: 0;
        font-size: .9em;
    }
    button:hover, button:active{
        background-color:#ad5457 ;
        color: black;
    }
</style>